import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const TracksTitle = styled.h3`
  margin-bottom: 2px;
  color: ${colors.mainText};
  font-weight: 600;
  font-size: 20px;
  @media ${device.mobileMin} {
    margin-bottom: 24px;
  }
`

export const TracksContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const Container = styled.div`
  box-sizing: border-box;
  padding-left: 31px;
  padding-right: 40px;
  width: 100%;

  @media screen and (max-width: 576px) {
    padding-left: 0;
    padding-right: 0;
  }
  @media screen and (min-width: 768px) {
    max-width: 1630px;
  }
`
